import { Component, inject, Input } from '@angular/core';
import { ApplicationStatusEnum, BriefStatusProgressDto } from '../../../../../common/general-types/briefs.dto';
import { FormatService } from '../../../../../common/format/format.service';
import { Router } from '@angular/router';

@Component({
  selector: 'brief-feed-auto-pilot-on',
  standalone: true,
  imports: [],
  templateUrl: './feed-auto-pilot-on.component.html',
  styleUrl: './feed-auto-pilot-on.component.css'
})
export class FeedAutoPilotOnComponent {

  @Input('activity') activity!: {
    applicationStatus: ApplicationStatusEnum;
    briefStatusProgress: BriefStatusProgressDto;
    date: Date;
  }

  features: { id: number, title: string, description: string }[] = [
    { id: 1, title: 'AI-Powered Creator Selection', description: 'Automatically hire creators based on your viability rules and brief requirements.' },
    { id: 2, title: 'Automated Communication', description: 'We handle the conversation & feedback with creators from application to content delivery.' },
    { id: 3, title: 'Smart Content Review', description: 'Content is automatically reviewed and approved if it passes all checks.' },
    { id: 4, title: 'Budget Protection', description: "We'll never spend beyond the budget you set for this brief." },
  ]

  /** Services */
  public formatService = inject(FormatService);
  private router = inject(Router);
  /** Services END */

  navigateToAutoHireConfig() {
    this.router.navigate(['/brief-auto-hire-config', this.activity.briefStatusProgress.briefId]);
  }

}
